var Pusher = require('pusher-js');

function pusherService() {

  var pusher = new Pusher(process.env.PUSHER_KEY);

  var routePlanChannels = [];
  var routePlanIds = {};

  var systemChannel;

  this.subscribeRoutePlan = function(routePlan, events) {
    if (routePlanIds[routePlan.id]) return;  // Already subscribed

    var channelName = 'routePlan_' + routePlan.id;
    var channel = subscribe(pusher, [channelName], events);

    routePlanIds[routePlan.id] = true;
    routePlanChannels.push(channel);
  };

  this.subscribeSystem = function(events) {
    if (systemChannel) {
      return;  // Already subscribed
    }

    systemChannel = subscribe(pusher, ['system'], events)[0];
  };

  this.unsubscribeAll = function() {
    unsubscribe(pusher, routePlanChannels);
    routePlanIds = {};
  };

  var unsubscribe = function(pusher, channels) {
    channels.forEach(function(channelName) {
      pusher.unsubscribe(channelName);
    });
  };

  var subscribe = function(pusher, channelNames, events) {
    var channels = [];

    channelNames.forEach(function(channelName) {
      var channel = pusher.subscribe(channelName);

      for (var event in events) {
        bindEvent(channel, event, events[event]);
      }
      channels.push(channelName);
    });

    return channels;
  };

  var bindEvent = function(channel, event, callback) {
    channel.bind(event, function(data) {
      console.log('Pusher', event, data);
      callback(data);
    });
  };

}

module.exports = pusherService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/pusher.js
 ** module id = 203
 ** module chunks = 1
 **/